export default __webpack_public_path__ + "static/1442-9205b47eeaeabdb99143c24a31e415fd.gif";